import Vue from 'vue'
import Router from 'vue-router'
import Imprint from '@/components/Imprint'
import Privacy from '@/components/Privacy'
import Faq from '@/components/Faq'
import Blog from '@/components/Blog'
import ParallaxPage from '@/components/ParallaxPage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  hashbang: false,
  transitionOnLoad: true,
  routes: [
    {
      path: '/imprint',
      component: Imprint
    },
    {
      path: '/gdpr',
      component: Privacy
    },
    {
      path: '/faq',
      component: Faq
    },
    {
      path: '/blog',
      component: Blog
    },
    {
      path: '/index2.html',
      component: ParallaxPage
    },
    {
      path: '/',
      component: ParallaxPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js